import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonComponentPreloaderComponent } from './ion-component-preloader.component';
import { IonicModule } from '@ionic/angular';



@NgModule({
  declarations: [IonComponentPreloaderComponent],
  imports: [
    CommonModule,
    IonicModule
  ],
  exports: [IonComponentPreloaderComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class IonComponentPreloaderModule { }
